/**
 * Copyright (c) 2021-present Alibaba Cloud, Inc
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import './index.less'
import React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Calculate height of iframe, the height support scaling height(100%\) and fixed height(100px\100vh)
 *
 * @param {any} height
 */
function calcHeight(height = '110vh') {
  if (window.isNaN(Number(height))) {
    return height
  }

  const { width } = document.body.getBoundingClientRect()
  return width * Number(height)
}

function IFrame({ src, name, height, ...props }) {
  const { pathname } = useLocation()

  const style = { height: calcHeight(height) }
  return <iframe src={src} className="IFrame" title={name} style={style} {...props} />
  // return <iframe src={`${src}#${pathname}`} className={appStyles.IFrame} title={name} style={style} {...props} />
}

export default IFrame
